import { render, staticRenderFns } from "./OurOfferCard.vue?vue&type=template&id=47b1b1b8&scoped=true&"
import script from "./OurOfferCard.vue?vue&type=script&lang=js&"
export * from "./OurOfferCard.vue?vue&type=script&lang=js&"
import style0 from "./OurOfferCard.vue?vue&type=style&index=0&id=47b1b1b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b1b1b8",
  null
  
)

export default component.exports